module.exports = __webpack_public_path__ + "static/media/proces_07.0e14b619.svg";